import styled from 'styled-components'

import { fonts, palette } from '../../styles/variables'
import { NavArrowIcon } from '../icon/Icon'
import { translate } from '../../utils/translation'

import { menuItems } from './menuContent'

const Container = styled.div({
  display: 'flex',
  flexDirection: 'column',
  fontSize: '14px',
  gap: '34px',
})

const Title = styled.h4({
  fontSize: '16px',
  marginBottom: '12px',
  marginTop: 0,
  fontFamily: fonts.primaryBold,
})

const SubTitle = styled.span({
  fontFamily: fonts.primaryMedium,
  fontWeight: 400,
})

const IconAndLabel = styled.div({
  display: 'flex',
  alignItems: 'center',
  gap: '12px',
})

const Label = styled.span({
  fontFamily: fonts.primaryMedium,
  fontSize: '14px',
})

const MenuButton = styled.button(({ selected }) => ({
  minWidth: '230px',
  height: '52px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  padding: '8px 14px 8px 8px',
  backgroundColor: selected ? palette.gray10 : 'transparent',
  color: selected ? palette.orange : 'inherit',
  outline: 'none',
  border: 'none',
  borderRadius: '2px',
  cursor: 'pointer',
}))

const MenuContainer = styled.div({
  display: 'flex',
  flexDirection: 'column',
  gap: '8px',
})

const SideMenu = ({ selected, setSelected }) => (
  <Container>
    <div>
      <Title>{translate('np_digital')}</Title>
      <SubTitle>{translate('np_offers')}</SubTitle>
    </div>
    <MenuContainer>
      {menuItems.map(({ key, label, icon }) => (
        <MenuButton
          key={key}
          onClick={() => setSelected(key)}
          selected={selected === key}
        >
          <IconAndLabel>
            <img src={icon} alt={`${key}-icon`} />
            <Label>{translate(label)}</Label>
          </IconAndLabel>
          {selected === key && (
            <div>
              <NavArrowIcon color={palette.orange} />
            </div>
          )}
        </MenuButton>
      ))}
    </MenuContainer>
  </Container>
)

export default SideMenu
